import React from "react";
import "../pages/AboutUs.css";
// Imported images
import img2 from "../asset/image/img2.jpg";
import img3 from "../asset/image/img3.jpg";
import img4 from "../asset/image/img4.jpg";
import imgp5 from "../asset/image/imgp5.jpg";
import img6 from "../asset/image/img6.jpg";
import img7 from "../asset/image/img7.jpg";
import img8 from "../asset/image/img8.jpg";
import img9 from "../asset/image/img9.jpg";

const AboutUs = () => {
  const containerStyle = {
    padding: "140px",
    maxWidth: "1200px",
    margin: "0 auto",
  };

  const headerStyle = {
    textAlign: "center",
    marginBottom: "40px",
    color: "#333",
    backgroundImage: `url(${img9})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: "60px 20px",
    borderRadius: "10px",
    color: "#fff",
  };

  const cardContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    marginBottom: "40px",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
    },
  };

  const cardImageStyle = {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderRadius: "8px",
    marginBottom: "15px",
  };

  const cardData = [
    {
      title: "Who We Are",
      image: img2,
      content:
        "We are a dedicated travel booking platform based in Sri Lanka, specializing in providing the best travel experiences across this beautiful island. Our mission is to connect you with authentic Sri Lankan destinations.",
    },
    {
      title: "Our Vision",
      image: img3,
      content:
        "Our vision is to promote Sri Lanka as a must-visit destination for travelers worldwide. We aim to create meaningful connections between our customers and the rich culture and natural beauty.",
    },
    {
      title: "Our Values",
      image: img4,
      isList: true,
      content: [
        {
          label: "Customer-Centric",
          text: "Your satisfaction is our priority",
        },
        { label: "Sustainability", text: "We support eco-friendly travel" },
        {
          label: "Authenticity",
          text: "We offer genuine Sri Lankan experiences",
        },
      ],
    },
    {
      title: "Why Choose Us?",
      image: imgp5,
      content:
        "With a local team of experts and years of experience, we bring you the best of Sri Lanka at affordable prices. Our booking platform is easy to use, ensuring a hassle-free planning experience.",
    },
  ];

  const additionalImagesStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    margin: "40px 0",
  };

  const additionalImageStyle = {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    borderRadius: "8px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  };

  return (
    <div style={containerStyle} className="about-container-media">
      <section style={headerStyle}>
        <h1
          style={{
            fontSize: "2.5rem",
            marginBottom: "10px",
            textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
          }}
        >
          About Us
        </h1>
        <p
          style={{
            fontSize: "1.2rem",
            textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
          }}
        >
          Your gateway to unforgettable Sri Lankan adventures!
        </p>
      </section>

      <div style={cardContainerStyle}>
        {cardData.map((card, index) => (
          <div key={index} style={cardStyle}>
            <img src={card.image} alt={card.title} style={cardImageStyle} />
            <h2 style={{ marginBottom: "15px", color: "#333" }}>
              {card.title}
            </h2>

            {card.isList ? (
              <ul style={{ listStyle: "none", padding: 0, margin: "15px 0" }}>
                {card.content.map((item, i) => (
                  <li
                    key={i}
                    style={{
                      margin: "10px 0",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <strong>{item.label}:</strong> {item.text}
                  </li>
                ))}
              </ul>
            ) : (
              <p style={{ color: "#666", lineHeight: "1.6" }}>{card.content}</p>
            )}
          </div>
        ))}
      </div>

      {/* Additional Images Gallery */}
      <div style={additionalImagesStyle}>
        <img
          src={img6}
          alt="Sri Lanka Experience 1"
          style={additionalImageStyle}
        />
        <img
          src={img7}
          alt="Sri Lanka Experience 2"
          style={additionalImageStyle}
        />
        <img
          src={img8}
          alt="Sri Lanka Experience 3"
          style={additionalImageStyle}
        />
      </div>

      {/* Footer Section */}
      <section
        style={{
          marginTop: "40px",
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${img9})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "#fff",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>Discover Sri Lanka With Us</h2>
        <p style={{ lineHeight: "1.6" }}>
          Book your perfect holiday with us and experience the magic of Sri
          Lanka. Whether you're looking for a relaxing beach holiday, an
          adventure-filled safari, or a cultural tour, we have the perfect
          options for you.
        </p>
      </section>
    </div>
  );
};

export default AboutUs;
